import styled from 'styled-components'

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0px 24px 24px 24px;
  height: calc(100vh - 56px);
  gap: 1rem;
`

export const ContainerButton = styled.div`
  display: flex;
  flex-direction: column;
`

export const ContainerIFrame = styled.div`
  padding-bottom: 4rem;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0px;
`

export const Wrapper = styled.div`
  background: var(--neutral-theme);
`

export const NewsBoxesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
`

export const Divider = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  margin: 24px 0;
  border: 1px dashed var(--gray200);
  border-style: dashed none none none;
`
